import React, { useState } from "react";
import OrdersBarChart from "./ordersCharts/ordersOverTime";
import OrderDistributionPieChart from "./ordersCharts/orderDistrubtionPieChart";
import ClientLineChart from "./ordersCharts/clientLineChart";
import ClientsPieChart from "./clientsCharts/clientsPieChart";
import DataTable from "../UI/table/DataTable";
import { getUsers } from "../../MyApi/user";
import { useQuery } from "react-query";
import TableActions from "../UI/table/TableActions";
import StatusBadge from "../UI/statusBadge";
import SkeletonWrapper from "../UI/skeletonWrapper";

const ClientsReportsTab = ({ statsWidget, isLoading }) => {
  const [current_page, setCurrentPage] = useState(1);
  const { data, isLoading:clientsLoading, isFetching } = useQuery(
    ["getUser", current_page],
    () => getUsers(current_page),
  );
  const users = data?.data.users || [];
  const userColumns = [
    { label: "معرف العميل", accessor: "id" },

    { label: "اسم العميل", accessor: "name" },
    { label: "الإيميل", accessor: "email" },
    { label: "رقم الهاتف", accessor: "phone" },
    { label: "عدد الطلبات", accessor: "order_count" },

    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge
          status={row.status ? "active" : "inactive"}
          statusLabel={row.status_label}
        />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={`${process.env.PUBLIC_URL}/user/${row.id}`}
          viewPermission={"view_user"}
        />
      ),
    },
  ];
  return (
    <div>
      <SkeletonWrapper isLoading={isLoading}>
        <div className="col-12">
          <ClientLineChart
            data={statsWidget?.charts?.user_over_time}
            barColor="#00C9A7"
            dataKeyX="date"
            dataKeyY="value"
            title={"الطلبات علي مدار الوقت"}
          />
        </div>
      </SkeletonWrapper>

      {/* <div className="row">
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <OrdersBarChart
              data={statsWidget?.charts?.top_stores_by_orders ||[]}
              barColor="#FFCC03"
              dataKeyX="name"
              dataKeyY="order_count"
              title={"الطلبات حسب نوع العميل"}
            />
          </SkeletonWrapper>
        </div>
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <ClientsPieChart
              data={statsWidget?.charts?.order_status_distribution || []}
            />
          </SkeletonWrapper>
        </div>
      </div> */}

      <div className="row">
        <div className="col-12">
          <SkeletonWrapper isLoading={isLoading}>
            <OrdersBarChart
              data={statsWidget?.customer_analytics?.top_cities}
              title={"أفضل 10 مدن من حيث عدد العملاء"}
              dataKeyX="city_name"
              dataKeyY="customer_count"
              barColor="#FFCC03"
              name={" العملاء"}
            />
          </SkeletonWrapper>
        </div>
      </div>

   
        <DataTable
          columns={userColumns}
          data={users || []}
          title="تفاصيل العملاء"
          totalItems={data?.data?.pagination?.total || 0}
          itemsPerPage={data?.data?.pagination.last_page}
          currentPage={current_page}
          setCurrentPage={setCurrentPage}
          isLoading={clientsLoading}
          isFetching={isFetching}
        />

    </div>
  );
};

export default ClientsReportsTab;
